<template>
  <b-row id="video-as-service" class="section-invert py-lg-5 py-0 reverse-sm">
    <b-col md="12" lg="6" class="p-0 p-lg-5">
      <div class="col-bg ml-lg-auto">
      </div>
    </b-col>
    <b-col md="12" lg="6" class="content my-auto">
      <h3>{{ $t('openlegal.video-service') }} </h3>
      <div class="subtitle">
        <p>{{ $t('openlegal.description') }}</p>
        <span>
          {{ $t('openlegal.how-to-request-video') }}
          <br><br>
          1. {{ $t('openlegal.steps.1')}}
          <br>
          2. {{ $t('openlegal.steps.2')}}
          <br>
          3. {{ $t('openlegal.steps.3')}}
          <br>
          4. {{ $t('openlegal.steps.4')}}
           <br>
           <br>
          <small>
            *{{ $t('openlegal.how-to-request-answer-2')}}
          </small>
        </span>
      </div>
      <base-button class="mt-5" white outline @click="$helpers.goToSection('contact-form')">{{ $t('openlegal.more-info') }}</base-button>
    </b-col>
  </b-row>
</template>

<script>
let messages = {
  'es': {
    'openlegal': {
      'video-service': 'Consultas por vídeo con tu abogado',
      'description': 'Aclara cualquier duda legal de manera rápida y sencilla con un abogado especializado, sin necesidad de molestias ni desplazamientos.',
      'how-to-request-video': '¿Cómo solicitas una consulta online con tu abogado?',
      'steps': {
        '1': 'Regístrate',
        '2': 'Elige el abogado',
        '3': 'Solicita la cita adjuntando la documentación que el caso requiera',
        '4': 'Abona la consulta utilizando una tarjeta de crédito o débito'
      },
      'how-to-request-answer-2': 'Recuerda que la tarjeta es necesaria para reservar la consulta, pero no se te cobrará nada hasta que la consulta se realice.',
      'hire-btn': 'Contrátalo por solo 39€'
    }
  },
  'en': {
    'openlegal': {
      'video-service': 'Video consultation with your lawyer',
      'description': 'Clarifies any legal question quickly and easily with a specialized lawyer, without any inconvenience or travel expenses.',
      'how-to-request-video': 'How do you request an online consultation with your lawyer?',
      'steps': {
        '1': 'Register',
        '2': 'Choose a lawyer',
        '3': 'Request the appointment by attaching the documentation that the case requires',
        '4': 'Pay the consultation using a credit or debit card'
      },
      'how-to-request-answer-2': 'Remember that the card is required to reserve the consultation, but you will not be charged until the consultation is made.',
      'hire-btn': 'Hire it for only 39€'
    }
  },
  'pt': {
    'openlegal': {
      'video-service': 'Consultas por vídeo com seu advogado',
      'description': 'Aclara qualquer dúvida legal de maneira rápida e simples com um advogado especializado, sem necessidade de molestias ou deslocamentos.',
      'how-to-request-video': 'Como solicitar uma consulta com seu advogado?',
      'steps': {
        '1': 'Registrar',
        '2': 'Escolher um advogado',
        '3': 'Solicite a marcação anexando a documentação que o caso exige',
        '4': 'Pagar a consulta usando uma cartão de crédito ou débito'
      },
      'how-to-request-answer-2': 'Lembre-se que a cartão é necessária para reservar a consulta, mas não seu pagamento até que a consulta seja realizada.',
      'hire-btn': 'Contrate-o por apenas 39€'
    }
  }
}

export default {
  i18n: {
    messages
  }
}
</script>

<style lang="scss" scoped>
#video-as-service {
  .col-bg {
    background-image: url('/static-appopensalud/img/bgs/openlegal/mockup-laptop-mac-video.png');
    @include desktop {
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: center;
    }

    @include mobile {
      /* margin-top: 4rem; */
      min-height: 33vh;
      background-size: cover;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/views/openlegal/OpenlegalVideoService.vue